import { AI_DECISION } from '../../global/constants/audit'
import { IAuditState } from '../../global/types/audit'

export const STATUS = {
  pass: AI_DECISION.pass,
  fail: AI_DECISION.fail,
  coached: 'coached',
}
function getStatusForAuditSection(
  auditState: IAuditState | null,
  section: string[],
) {
  if (!auditState) {
    return STATUS.pass
  }
  const areAllSectionsPassing = section.every((section) => {
    const auditSection = auditState[section]
    const needsCoaching = auditSection?.coaching?.needsCoaching
    return !auditSection || !needsCoaching
  })
  if (areAllSectionsPassing) {
    return STATUS.pass
  }
  const areAllSectionsCoachedThatNeedCoaching = section.every((section) => {
    const auditSection = auditState[section]
    const needsCoaching = auditSection?.coaching?.needsCoaching
    const coached = auditSection?.coaching?.coached
    return auditSection && needsCoaching && coached
  })
  if (areAllSectionsCoachedThatNeedCoaching) {
    return STATUS.coached
  }
  return STATUS.fail
}

export default getStatusForAuditSection
